import styled from "styled-components";

export const Header = styled.div`
  min-height: 73px;
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
  padding: 0 30px;
  background: #f2f2f2;
  border-bottom: 1px solid #0000001a;
  position: relative;
  justify-content: flex-end;
  gap: 25px;
  .heading {
    h1 {
      font-size: 30px;
      line-height: 150.5%;
      text-transform: capitalize;
      margin-bottom: 5px;
      font-family: "latosemibold";
    }
    p {
      font-size: 14px;
      line-height: 150.5%;
      color: #0009;

      span {
        font-family: "latobold";
        color: #000;
      }
    }
  }
  .role-wrapper {
    display: flex;
    align-items: center;
    gap: 25px;
    button {
      padding: 0;
      background: 0;
      border: none;
    }
    .MuiNativeSelect-select {
      padding: 9px 43px 9px 14px !important;
      z-index: 1;
      position: relative;
    }
    .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    .MuiInputBase-root {
      font-size: 13px;
      font-weight: 500;
      border: 1px solid #cccccc;
      border-radius: 6px;
      position: relative;
    }
    .arrow-icon {
      padding: 8px 13px;
      position: absolute;
      right: 0;
      border-left: 1px solid #cccccc;
      z-index: 0;
    }
  }
  .role {
    display: flex;
    align-items: center;
    gap: 20px;
    padding-right: 39px;
    border-right: 1px solid #00000033;
    min-height: 138px;

    > div {
      width: 107px;
      height: 107px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background: #999999;
      text-transform: uppercase;
      border-radius: 50%;
      font-size: 24px;
      line-height: 150.5%;
      font-family: "latomedium";
      max-height: calc(100vh - 129px);
    }
  }
    @media (max-width: 820px) {
    width: 100%;
    .role-wrapper {
    width:102%;
    }
  }
`;

export const BodyWrapper = styled.div`
  padding: 30px 10px;
  background: #f2f2f2;
  max-height: calc(100vh - 129px);
  overflow: auto;
  @media (max-width: 820px) {
    padding: 30px 20px 30px 10px;
    overflow-x: hidden !important;
    width: 100%;
    max-width: 100vw;
  }
`;
export const TopRow = styled.div`
  /* margin-bottom: 20px; */
  @media (max-width: 820px) {
    padding-right: 10px; 
    box-sizing: border-box;
  }
`;
export const TopBox = styled.div`
  border: 1px solid #ffffff;
  position: relative;
  min-height: 300px;
  background: #fffcfa;
  box-shadow: 0px 4px 15px rgb(0 0 0 / 5%);
  border-radius: 6px;
  cursor: pointer;
  :after {
    background:${({ noAfter }) => (noAfter ? 'none' : '#947550')};
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    content: "";
    display: block;
    width: 100%;
    height: 5px;
    position: absolute;
    bottom: 0;
  }
  &.chat-box {
    background: linear-gradient(180deg, #af815c 0%, #000000 100%);
    .title {
      color: #fff;
    }
  }
  .chat-btn {
    font-family: "Roboto";
    font-weight: 500;
    font-size: 16px;
    line-height: 150.5%;
    padding: 3px 5px;
    border: 1px solid #947550;
    border-radius: 5px;
    background-color: transparent;
    color: #ffffff;
    margin-top: 20px;
  }
  .header {
    display: flex;
    gap: 6px;
    align-items: center;
    padding: 13px 14px 13px;
    width: 100%;
    margin: 0 auto;
    border-bottom: 1px solid #bbbbbb99;
    p {
      font-size: 16px;
      line-height: 150.5%;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      font-weight: 500;
      color: #000;
      position: relative;
      &.green-border {
        ::after {
          background: #63ad53;
        }
      }
      &.blue-border {
        ::after {
          background: #579afd;
        }
      }
      &.see-green-border {
        ::after {
          background: #4cd9c6;
        }
      }
      &.red-border {
        ::after {
          background: #fa3c30;
        }
      }
      ::after {
        content: "";
        height: 5px;
        background: #ffe500;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        display: inline-block;
        width: calc(100% + 42px);
        position: absolute;
        bottom: -14px;
        left: -35px;
      }
    }
  }
  .box-body {
    padding: 0 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    height: calc(100% - 51px);
    &.car-round-status {
      padding: 0 15px;
      justify-content: flex-start;
      ul {
        width: 100%;
        margin: 5px 0;
        li {
          padding: 5px 0;
          border-bottom: 1px solid #0000001a;
          display: flex;
          align-items: center;
          justify-content: space-between;
          p:nth-child(2) {
            font-size: 24px;
            line-height: 200%;
            color: #000;
          }
          :last-child {
            border: none;
          }
        }
      }
    }
    &.action-zone-infraction {
      display: flex;
      flex-direction: column;
      padding: 19px 23px;
      gap: 5px;
      > div {
        display: flex;
        align-items: center;
        height: 100%;
        justify-content: center;
        position: relative;
        justify-content: space-between;
        background: #ffffff;
        border: 1px solid #fcf7ef;
        box-shadow: 0px 14px 35px rgba(205, 207, 208, 0.2);
        border-radius: 10px;
        width: 100%;
        padding: 0 20px 0 10px;
        span {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #c4c4c433;
          border-radius: 50%;
          margin-bottom: 15px;
        }
        p {
          font-weight: 400;
          font-size: 14px;
          line-height: 150.5%;
          margin-bottom: 3px;
          display: flex;
          align-items: center;
          gap: 11px;
          min-width: 132px;
        }
        h4 {
          font-size: 26px;
          line-height: 30px;
          text-align: center;
          color: #fa3c30;
          font-weight: 400;
        }
      }
    }
    &.battery-notification-section {
      padding: 18px 20px 20px;
      > div {
        background: #fffcfa;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        border-radius: 10px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        height: 100%;
        width: 100%;
        > div {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          :nth-child(1),
          :nth-child(2) {
            border-bottom: 1px solid #cccccc4d;
          }
          :nth-child(2),
          :nth-child(4) {
            border-left: 1px solid #cccccc4d;
          }
        }
        h3 {
          align-items: center;
          justify-content: center;
          font-weight: 500;
          font-size: 24px;
          line-height: 150.5%;
          span {
            background: #ffffff;
            box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
            display: inline-flex;
            height: 30px;
            width: 30px;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            margin-left: 10px;
          }
        }
        p {
          font-weight: 500;
          font-size: 14px;
          line-height: 150.5%;
          color: #666666;
          margin-top: 10px;
        }
        .battery-wrapper-section {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 15px;
          h3 {
            :nth-child(2) {
              border-left: 1px solid #bc9b6a99;
              padding-left: 15px;
            }
          }
        }
      }
    }
    &.cart-path-rule {
      padding: 5px 14px;
      justify-content: space-between;
      align-items: flex-start;
    }
    &.welcome-screen {
      img {
        width: 100%;
        max-width: 100%;
        height: auto;
        object-fit: contain;
        overflow: hidden;
      }
    }
    &.map-section {
      img {
        max-width: 100%;
        width: 100%;
        height: auto;
        object-fit: contain;
        overflow: hidden;
        padding: 30px;
      }
    }
    &.weather-report {
      background: radial-gradient(50% 50% at 50% 50%, #fff2c8 0%, #ffe79c 100%);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: stretch;
      padding: 18px 14px;
      .main-temp {
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
          font-weight: 500;
          font-size: 14px;
          line-height: 150.5%;
        }
        h3 {
          font-weight: 700;
          font-size: 14px;
          color: #1d1d1d;
        }
      }
      .center-row {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .bottom-detail-row {
        display: flex;
        justify-content: space-around;
        min-height: 70px;
        align-items: center;
        gap: 8px;
        .bottom-detail {
          display: flex;
          align-items: center;
          gap: 8px;
          h3 {
            font-weight: 500;
            font-size: 18px;
            line-height: 150.5%;
          }
          p {
            font-size: 14px;
            line-height: 150.5%;
          }
        }
      }
    }
    &.car-selection-section {
      background: #fffcfa;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 14px;
      > div {
        background: #ffffff;
        border: 1px solid #fcf7ef;
        box-shadow: 0px 14px 35px rgba(205, 207, 208, 0.2);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-items: center;
        position: relative;
        padding-top: 25px;
        padding-bottom: 3px;
        margin-top: 25px;
        /* width: 70%; */
        text-align: center;
        .see-green {
          color: #00a692;
        }
        .yellow {
          color: #ffd706;
        }
        .red {
          color: #fa3c30;
        }
        svg {
          position: absolute;
          top: calc(-50% - -21px);
        }
        h2 {
          font-size: 32px;
          line-height: 38px;
          font-weight: 400;
        }
        h3 {
          font-weight: 400;
          font-size: 12px;
          line-height: 15px;
          margin-top: 7px;
        }
        p {
          font-size: 14px;
          line-height: 150.5%;
          color: #666666;
        }
      }
    }
    &.day-box-body {
      justify-content: space-evenly !important;
      .day-div {
        position: relative;
        flex: unset !important;
        width: fit-content;
        .round {
          position: absolute;
          font-size: 24px;
          line-height: 29px;
          color: #ffffff;
          font-family: "latobold";
          bottom: 37px;
          right: 0;
          left: 0;
        }
      }
    }

    .ghin-status-section {
      max-width: 216px;
      background: #f9f9f9;
      border: 5px solid #ffffff;
      box-shadow: 0px 14px 35px rgba(205, 207, 208, 0.2);
      border-radius: 10px;
      width: 100%;
      text-align: center;
      padding: 25px;
      h3 {
        font-style: normal;
        font-weight: 500;
        font-size: 64px;
      }
      p {
        font-weight: 500;
        font-size: 20px;
        line-height: 150.5%;
        color: #000;
      }
    }
    .bp-heading {
      font-weight: 500;
      font-size: 64px;
      line-height: 75px;
      margin-top: 15px;
    }
    .bp-sub-heading {
      font-weight: 500;
      font-size: 16px;
      line-height: 150.5%;
      color: #616264;
    }
    .holes-data {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      font-size: 14px;
      line-height: 150.5%;
      padding: 11px 0;
      .MuiTypography-root {
        font-size: 14px;
      }
    }
    .holes {
      display: flex;
      gap: 18px 30px;
      flex-wrap: wrap;
      button {
        width: 35px;
        height: 35px;
        background: #dadada;
        font-size: 16px;
        color: #000000;
        font-weight: 500;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: "latomedium";
        border: 1px solid #bc9b6a;
        box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.15);
        &.selected {
          background: #947550;
          color: #ffffff;
          border: 1px solid #947550;
        }
      }
    }
    .city {
      font-weight: 500;
      font-size: 16px;
      line-height: 150.5%;
      color: #616264;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      padding-top: "20px";
    }
    &.pace-report {
      background: #f9f9f9;
      img {
        width: 100%;
        max-width: 100%;
        height: auto;
        object-fit: contain;
        overflow: hidden;
      }
    }
    .amr-report-section {
      max-width: 249px;
      background: #f9f9f9;
      border: 5px solid #ffffff;
      box-shadow: 0px 14px 35px rgb(205 207 208 / 20%);
      border-radius: 10px;
      width: 100%;
      text-align: center;
      img {
        width: 100%;
        max-width: 100%;
      }
    }
    &.pace-section {
      padding: 14px 20px;
      gap:10px;
      > div {
        width: 100%;
        text-align: center;
        :nth-child(odd) {
          background: #c4c4c41a;
          border-bottom: 1px solid #cccccc99;
        }
        h4 {
          font-weight: 500;
          font-size: 20px;
          line-height: 150.5%;
          padding-bottom: 5px;
        }
        p {
          font-weight: 500;
          font-size: 14px;
          line-height: 150.5%;
          padding-bottom: 7px;
          color: #666666;
        }
      }
    }
    &.fleet-readiness-section {
      padding: 14px 20px 20px;
      > div {
        background: #c4c4c41a;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        > div {
          width: 100%;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          :nth-child(odd) {
            border-bottom: 1px solid #cccccc99;
          }
          h4 {
            font-weight: 500;
            font-size: 24px;
            line-height: 150.5%;
            padding-bottom: 5px;
          }
          p {
            font-weight: 500;
            font-size: 14px;
            line-height: 150.5%;
            padding-bottom: 7px;
            color: #666666;
          }
        }
      }
    }
    &.today-rounds-section {
      flex-direction: row;
      justify-content: space-around;
      > div {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .bp-heading {
          font-size: 28px;
          line-height: 150.5%;
          margin: 0;
        }
        .bp-sub-heading {
          margin-top: 11px;
        }
      }
    }
  }

  &.fleet-car-rotation {
    .box-body {
      flex-direction: row;
      gap: 0;
      justify-content: center;
      align-items: center;
      > svg {
        flex: 1;
      }
      > div {
        text-align: center;
        flex: 1;
      }
      .first-section {
        margin-bottom: 14px;
        padding-bottom: 14px;
        border-bottom: 1px solid #bc9b6a;
      }
      h2 {
        font-size: 28px;
        line-height: 150.5%;
        font-weight: 500px;
        font-family: "Roboto", "Helvetica", "Arial", sans-serif;
        margin: 0;
      }
      p {
        font-size: 16px;
        line-height: 150.5%;
        font-weight: 500px;
        font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      }
    }
  }
@media (max-width: 820px) {
  width: 100% !important;
  max-width: 100% !important;
  flex: 0 0 100% !important;
  grid-column: 1 / -1 !important;
  overflow-x: hidden !important;
.box-body {
  height: auto !important;
  max-height: none !important;
  overflow-y: visible !important; /* to prevent inner scrollbar */
}
  .header p::after {
    width: 100% !important;
    left: 0 !important;
  }

  .car-movement,
  .car-movement * {
    max-width: 100% !important;
    overflow-x: hidden !important;
    box-sizing: border-box;
    word-break: break-word;
  }
  .cart-path-rule {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100% - 51px); /* to ensure it takes full height minus header */
    padding-bottom: 14px; 
    }
  .city{
    text-align: left;
    padding-top: 10px;
    } 
}
`;

export const MiddleTopRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
  ${TopBox} {
    min-height: 400px;

    .box-body {
      height: calc(100% - 51px);
    }
  }
`;

export const CampaignAdsSlider = styled.div`
  margin-bottom: 20px;
  padding: 0 20px;
  ${TopBox} {
    height: auto;
    ::after {
      display: none;
    }
    .slider-section {
      padding: 0 90px;
      position: relative;
      .MuiBox-root {
        position: absolute;
        width: 157px;
        right: 40px;
        top: -43px;
      }
      .MuiNativeSelect-select {
        padding: 5px 32px 5px 15px;
        border: 1px solid #bbbbbb;
        border-radius: 6px;
        font-weight: 500;
        color: #000;
      }
      .MuiInputBase-root::before {
        display: none;
      }
    }
  }
      @media (max-width: 820px) {
    padding: 0 10px !important;
   width: 102% !important;
    margin-left:10px;
    ${TopBox} {
      height: auto !important;

      .slider-section {
        padding: 0 10px !important;

        .MuiBox-root {
          margin-top: 0px !important;
          margin-left: auto !important;
          margin-left: 85% !important;
          width: fit-content !important;
          display: block !important;
          position: relative !important;
        }
      }
    }
  }
`;

export const EventSurveySection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 20px;

  gap: 20px;
  ${TopBox} {
    height: 617px;
    ::after {
      display: none;
    }
  }
`;

export const FBChartSection = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
  ${TopBox} {
    height: 642px;
    img {
      width: 100%;
      max-width: 100%;
    }
    ::after {
      display: none;
    }
  }
`;

export const PaceFleetChartSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  padding: 0 20px;
  &.dis_flex_fleet {
    display: flex;
    > div {
      width: 50%;
    }
  }
  ${TopBox} {
    height: 542px;
    img {
      width: 100%;
      max-width: 100%;
    }
    ::after {
      display: none;
    }
  }
   @media (max-width: 820px) {
    /* MOBILE ONLY CHANGES */
    padding: 0 10px !important;
    width: 102% !important;
    margin-left: 10px;

    &.dis_flex_fleet {
      flex-direction: column; // stack cards vertically
      > div {
        width: 90% !important;
        margin: 0 auto 20px auto; 
      }
    }

    ${TopBox} {
      height: auto !important; 
      min-height: 300px;
    }
  }
`;

export const SettingContainer = styled.div`
  box-shadow: 10px 4px 20px rgba(0, 0, 0, 0.1);
  position: absolute;
  right: 0;
  left: 0;
  height: calc(100vh - 78%);
  background: #f2f2f2;
  padding: 0 30px 37px;
  top: 0;
  z-index: 1;
  .close-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 17px;
    button {
      display: flex;
      align-items: center;
      font-family: "Roboto";
      font-weight: 500;
      font-size: 16px;
      line-height: 150.5%;
      gap: 8px;
      border: none;
      padding: 0;
      background-color: transparent;
    }
  }
  .action-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 15px;
    margin-top: 15px;
    button {
      min-width: 68px;
    }
  }

  .action-wrappers {
    display: flex;
    align-items: center;
    gap: 5px;
    button {
      font-size: 12px;
      line-height: 150.5%;
      color: #1d1d1d;
      padding: 5px 10px;
      border: 1px solid #636f7c;
      border-radius: 30px;
      display: flex;
      align-items: center;
      min-width: 72px;
      min-height: 31px;
      gap: 5px;
      background-color: #fff;
      font-family: "latobold";
      text-transform: inherit;
      justify-content: center;

      &.active {
        background: #bc9b6a;
        color: #fff;
        border-color: transparent;
      }
      &.disabled {
        pointer-events: none;
        cursor: default;
        color: rgba(0, 0, 0, 0.26);
      }
    }
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: clamp(10px, 3.125vw, 60px);
  > div {
    flex: 1;
    position: relative;

    ::after {
      content: "";
      display: inline-block;
      width: 100%;
      height: 1px;
      background: #bc9b6a;
      position: absolute;
      top: 34px;
      left: 0;
      z-index: 0;
    }
    h3 {
      font-family: "Roboto";
      font-weight: 500;
      font-size: 16px;
      line-height: 150.5%;
      /* border-bottom: 1px solid #bc9b6a; */
      margin-bottom: 6px;
      position: relative;
      padding-bottom: 11px;
      display: inline-block;
      ::after {
        content: "";
        display: inline-block;
        width: 100%;
        height: 5px;
        background: #579afd;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        transform: matrix(1, 0, 0, -1, 0, 0);
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
        min-width: 140px;
      }
      &.yellow-border {
        ::after {
          background: #ffe500;
        }
      }
      &.red-border {
        ::after {
          background: #fa3c30;
        }
      }
      &.green-border {
        ::after {
          background: #63ad53;
        }
      }
      &.brown-border {
        ::after {
          background: #b29d64;
        }
      }
    }
    > button {
      font-size: 14px;
      line-height: 150.5%;
      font-family: "Roboto";
      border: 1px solid #c4c4c4;
      border-radius: 4px;
      min-height: 46px;
      padding: 10px;
      display: flex;
      align-items: center;
      background-color: #fff;
      gap: 9px;
      margin-bottom: 4px;
      width: 100%;
      &.selected {
        background: linear-gradient(90deg, #bc9b6a 9.9%, #947550 100%);
        color: #ffffff;
      }
    }
  }
    @media (max-width: 820px) {
  width: 100% !important;
  display: block !important;
  padding-right: 10px; 
  overflow-x: hidden !important;
}
`;

export const TodayPinPositionModalBody = styled.div`
  padding: 30px 34px;
  display: flex;
  align-items: center;
  gap: 30px;
  /* to allow internal scrolling when the modal content is taller than maxHeight */
  overflow: hidden;
  > div {
    width: 100%;
    display: grid;
    grid-template-rows: 51px 1fr;

    .box-body {
      height: 100%;
      /* to allow images/content to fit and scroll inside each box-body */
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      
    }
  }

  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;

    /* allow scroll */
    max-height: calc(80vh - 80px); 
    overflow-y: auto;
     padding: 24px 20px 32px 20px

    > div {
      width: 100%;

      .box-body {
        min-height: 180px;
        max-height: 40vh;
        overflow-y: auto;
        
      }
    }
  }
`;

export const ModalBody = styled.div`
  padding: 37px 43px;
  display: flex;
  align-items: flex-start;
  > div {
    flex: 1;
  }

  .image-container {
    max-width: 340px;
    padding: 0 30px;
    p {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 150.5%;
      color: #000000;
      margin-bottom: 10px;
    }
  }
`;

export const ActionZoneModalContainer = styled.div``;

export const ActionZoneModalModalBody = styled.div`
  padding: 0 24px 20px;
  table {
    border-collapse: collapse;
    border-collapse: separate;
    border-spacing: 0 15px;
    width: 100%;
    tr {
      background: #f9f9f9;
      border: 1px solid #e5e5e5;
      box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      :first-child {
        box-shadow: none;
        border-radius: 0;
        border: none;
        background: #fff;
      }
      th {
        padding: 7px 20px;
        font-weight: 500;
        font-size: 14px;
        line-height: 150.5%;
        font-family: "Roboto";
        color: #1d1d1d;
        text-align: left;
        white-space: nowrap;
        :first-child {
          width: 103px;
          text-align: center;
        }
      }
      td {
        padding: 7px 20px;
        :first-child {
          text-align: center;
        }
      }
    }
  }
`;
export const DragIndicatorOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 9999;
  ${({ active }) => active && `
    &::before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(188, 155, 106, 0.1);
      animation: dragActivePulse 0.5s ease-out;
    }
    
    @keyframes dragActivePulse {
      0% {
        opacity: 0.3;
      }
      100% {
        opacity: 0;
      }
    }
  `}
`;